export default __webpack_public_path__ + "static/media/Anova-BoldItalic.2c38ceb2.woff2";